// extracted by css-extract-rspack-plugin
export default {"SnippetButton":"kzH_g","SnippetContent":"DnhNM","SnippetIcon":"n9TZu"};